import { useContext } from 'react';

import { ICellRendererParams } from '@ag-grid-community/core';

import { BodySmall, Box, Checkbox, Menu, Status } from '@parspec/pixel';

import { ColorCode } from 'src/features/shared/constants';
import { MenuContext } from './context';
import { PricingHistoryTableDataType } from './types';
import { PARSPEC_RECORD_TOOLTIP_INFO, PROJECT_SOURCE_LABEL_ENUM, SOURCE_TO_COLOR_MAP } from '../constant';

export function MenuOption(props: ICellRendererParams) {
    const { data } = props;
    const { source } = data;
    const { onDelete } = useContext(MenuContext);
    const isDeleteDisabled = source === PROJECT_SOURCE_LABEL_ENUM.PARSPEC;

    const options: {
        label: React.ReactNode | string;
        onClick: () => void;
        color?: string | undefined;
        disabled?: boolean | undefined;
        toolTipMessage?: string | undefined;
    }[] = [
            {
                label: 'Delete',
                onClick: () => onDelete(data),
                disabled: isDeleteDisabled,
                color: 'error.main',
                toolTipMessage: isDeleteDisabled ? PARSPEC_RECORD_TOOLTIP_INFO : ''
            }
        ];

    return (
        <Box display="flex" justifyContent="center">
            <Menu options={options} />
        </Box>
    );
}

export const CustomCheckboxRenderer = (props: { params: ICellRendererParams, selectedItems: PricingHistoryTableDataType[], setSelectedItems: React.Dispatch<React.SetStateAction<PricingHistoryTableDataType[]>>; }) => {
    const { params, selectedItems, setSelectedItems } = props;
    const isChecked = selectedItems.some(rec => rec.uid === params?.data?.uid)

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event?.target?.checked;
        if (checked) {
            setSelectedItems(prev => [...prev, params?.data])
        } else {
            setSelectedItems(prev => prev.filter(record => record.uid != params?.data?.uid))
        }
    };
    return (
        <Checkbox checked={isChecked} onChange={handleCheckboxChange} label='' disabled={params?.data?.source !== PROJECT_SOURCE_LABEL_ENUM.IMPORT} />
    );
};
export const CustomCheckboxHeader = (props: { rowCount: number, selectedItems: PricingHistoryTableDataType[], handleSelectAll: (checked: boolean) => void }) => {
    const { rowCount, selectedItems, handleSelectAll } = props;
    const isChecked = selectedItems.length === rowCount && !!rowCount;
    return <Checkbox checked={isChecked} onChange={(e) => handleSelectAll(e.target.checked)} label='' />
}

export const GetSourceTemplate = ({ source }: { source: string }) => {
    const color = SOURCE_TO_COLOR_MAP[source as keyof typeof SOURCE_TO_COLOR_MAP] as ColorCode;
    return (
        <Box height="100%" display="flex" flexDirection="column" justifyContent="center">
            <Status color={color}>
                <BodySmall color={color}>{source}</BodySmall>
            </Status>
        </Box>
    );
};